import { useState } from "react";
import "./index.css";
import AdminParfumeModal from "../AdminParfumeModal";

type Accord = { phase: "top"|"heart"|"base"; ingredient: string; drops?: number };
export type Formula = { style?: string; details?: string; accords?: Accord[] };
export type Parfume = {
  id: string;
  name: string;
  img?: string;
  description?: string;    // ассоциация клиента
  formula?: Formula | null;
};

function phaseLabel(ph: Accord["phase"]) {
  if (ph === "top") return "Верх";
  if (ph === "heart") return "Сердце";
  if (ph === "base") return "База";
  return ph;
}

export default function AdminParfumesTable({
  parfumes,
  onSave,     // (id, patch) => Promise<void>
}: {
  parfumes: Parfume[];
  onSave: (id: string, patch: Partial<Parfume>) => Promise<void> | void;
}) {
  const [opened, setOpened] = useState<Parfume | null>(null);

  return (
    <>
      <div className="tableWrap">
        <table className="table parf ro">
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Фото</th>
              <th style={{ width: "10%" }}>Название</th>
              <th style={{ width: "20%" }}>Ассоциация</th>
              <th style={{ width: "20%" }}>Стиль</th>
              <th style={{ width: "45%" }}>Формула</th>
            </tr>
          </thead>
          <tbody>
            {parfumes.map((p) => {
              const f = p.formula || { accords: [] };
              return (
                <tr
                  key={p.id}
                  className="rowClickable"
                  onClick={() => setOpened(p)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === "Enter") setOpened(p); }}
                >
                  <td>
                    <div
                      className="thumb"
                      style={p.img ? { backgroundImage: `url(${p.img})` } : {}}
                    />
                  </td>

                  <td>
                    <div className="tTitle">{p.name || "—"}</div>
                  </td>

                  <td>
                    <div className="tAssoc">{p.description || "—"}</div>
                  </td>

                  <td>
                    <div className="tStyle">{f.style || "—"}</div>
                  </td>

                  <td>
                    <div className="tFormula">
                      {(f.accords || []).length === 0 && <span className="muted">нет</span>}
                      {(f.accords || []).map((a, i) => (
                        <span key={i} className="pillChip">
                          <b>{phaseLabel(a.phase)}:</b>&nbsp;
                          {a.ingredient}
                          {typeof a.drops === "number" ? ` — ${a.drops} кап.` : ""}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              );
            })}
            {parfumes.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">Нет парфюмов</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {opened && (
        <AdminParfumeModal
          parfume={opened}
          onClose={() => setOpened(null)}
          onSave={async (patch) => {
            await onSave(opened.id, patch);
            setOpened(null);
          }}
        />
      )}
    </>
  );
}
